import ReservationThresholds from "../../components/reservation-thresholds";
import HeaderPage from "../../components/lines-managements/header/HeaderPage";

const ReservationThresholdsPage: React.FC = () => {
  return (
    <>
      <HeaderPage
        link={{
          to: "add",
          children: "Shto prag te ri",
          state: ["Reservation Thresholds", "Shto prag te ri"]
        }}
      />
      <ReservationThresholds />
    </>
  );
};

export default ReservationThresholdsPage;
